@if (activeDepositCurfew && !isInPlayBreak) {
    <show-message [type]="messageType.INFO">
        <div info>
            <span>
                {{ 'PARTY.CASHIER.web.deposit.curfew.new.message1' | translate }}
                <span translate="{{ 'PARTY.CASHIER.web.deposit.curfew.new.message1' }}"></span>
            </span>
            <a href="{{ depositCurfewRedirectUrl }}" target="_top" class="ml-1">
                <span>{{ 'PARTY.CASHIER.web.deposit.curfew.new.message2' | translate }}</span>
            </a>
        </div>
    </show-message>
}
